import SettingDTO from 'dto/tenants/settingDTO';
import Setting, { Settings } from 'models/tenants/setting';

export function mapFromSettings(settingDTOs: SettingDTO[] | undefined): Settings {
  const settings = new Settings();
  settings.items = (settingDTOs ?? []).map((settingDTO) => {
    const newSetting = new Setting();
    newSetting.settingName = settingDTO.settingName;
    newSetting.settingValue = settingDTO.settingValue;

    return newSetting;
  });

  return settings;
}
